function Answers() {
  return (
    <>
      <section class="l-contain l-section questions">
        <h2 class="u-small-title">
          Quick Answers To Questions You May Have About Me
        </h2>

        <div class="accordion-wrapper">
          <div class="accordion">
            <input type="radio" name="radio-a" id="check1" />
            <label class="accordion-label" for="check1">
              How many years of experience in Product Management do you have?
            </label>
            <div class="accordion-content">
              <p>
                I have about 2 years of relevant experience in Product
                Management.
              </p>
            </div>
          </div>
          <div class="accordion">
            <input type="radio" name="radio-a" id="check2" />
            <label class="accordion-label" for="check2">
              What roles are you looking for?
            </label>
            <div class="accordion-content">
              <p>
                I am primarily looking for an Associate Product Manager role.
              </p>
            </div>
          </div>
          <div class="accordion">
            <input type="radio" name="radio-a" id="check3" />
            <label class="accordion-label" for="check3">
              What are soft skills do you have?
            </label>
            <div class="accordion-content">
              <p>
                People Management | Time Management| Optimization and
                prioritization | Leadership |Attention to Detail |Creativity and
                Innovation | Effective Communication | Interpersonal Skills |
                Event Planning
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Answers;
